import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Pages from './Pages'

type LoginFlowProps = {}

const LoginFlow: React.FC<LoginFlowProps> = () => {
  return (
    <>
      <Routes>
        {/* The "base" route - shows LoginPageBankID, now the primary login flow */}
        <Route element={<Pages.LoginPageBankID />} path="/" />
        <Route element={<Navigate to="/" />} path="*" />
      </Routes>
    </>
  )
}

export default LoginFlow
